import { createStore, useStore as baseUseStore, Store } from 'vuex'
import { MeterType, TimeSignatureType, TRegister } from './types'
import { InjectionKey, watch } from 'vue';
export interface State {
      apiUrl: string,
    ui: {
      showSidebar: boolean,
      openedWindows: Window[],
      midiPlayerIntervals: number[]
    },

    debug: {
      isDevEnv: boolean,
      content: string[]
    },
    exercise: {
      register: TRegister,
      midiPlayer: {
        tempo: number,
        beatsTimestamps: number[]
      },
      timeSignature: TimeSignatureType,
      meterType: MeterType
    },
    pitchDetector: {
      currentPname: string
    }
}
export const store =  createStore<State>({
  state: {
    // apiUrl: 'http://localhost:4000',
    // apiUrl: 'http://192.168.43.69:4000',
    apiUrl: process.env.VUE_APP_API_URL || '',
    
    ui: {
      showSidebar: true,
      openedWindows: <Window[]> [],
      midiPlayerIntervals: <number[]> []
    },

    debug: {
      isDevEnv: process.env.VUE_APP_MODE == 'development',
      content: ['']
    },
    exercise: {
      register: <TRegister> {
      },
      midiPlayer: {
        tempo: 80,
        beatsTimestamps: []
      },
      meterType: MeterType.SIMPLE,
      timeSignature: '2-4'
      
    },
    pitchDetector: {
      currentPname: <string> ''
    }
  },
  getters: {

  },
  mutations: {
  },
  actions: {
    setRegister(context, register: TRegister) {
      context.state.exercise.register.from = register.from;
      context.state.exercise.register.to = register.to;
    }
  },
  modules: {
  }
})


export const useStoreKey: InjectionKey<Store<State>> = Symbol();
export function useStore() {
  return baseUseStore(useStoreKey)
}

